module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.data), function(product, key) {
    return _c('div', {
      staticClass: "textfield",
      staticStyle: {
        "padding": "2px 0"
      },
      style: (key !== 0 ? 'border-top: 2px solid #eaeaea;' : ''),
      domProps: {
        "innerHTML": _vm._s(product)
      }
    })
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31380568"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/table-field/FieldTexts.vue
// module id = 671
// module chunks = 0